/**
 * Tetris game parameters — tune difficulty here, not in components.
 * All timing values are in milliseconds.
 */

// ⚙️ Tune difficulty here
export const TETRIS_CONFIG = {
  /** Drop interval at level 1 (ms). Default in cibulka is ~500ms — raised to avoid being brutal. */
  initialDropInterval: 800,
  /** Speed increase per level (ms reduction per level). */
  intervalDecrement: 50,
  /** Minimum drop interval — fastest possible speed (ms). */
  minDropInterval: 100,
  /** Lines to clear before advancing one level. */
  linesPerLevel: 10,
  boardWidth: 10,
  boardHeight: 20,
} as const;
